import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fmtDateTime, imgSrc } from "../lib/api";
import { ARTICLE_TYPES, STATUS_LABELS } from "../lib/brand";
import { BrandLoader } from "../components/site/Logo";
import { btnGhost } from "./ui";

export default function ArticlePreview() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    api.get(`/admin/articles/${id}`).then((r) => setA(r.data));
  }, [id]);
  if (!a) return <BrandLoader />;
  return (
    <div className="min-h-screen bg-surface py-6" data-testid="article-preview">
      <div className="mx-auto mb-4 flex max-w-5xl items-center justify-between px-4 text-sm">
        <span className="rounded bg-amber-100 px-2 py-1 font-semibold text-amber-950">PREGLED · {STATUS_LABELS[a.status]} · nije javno</span>
        <div className="flex gap-2">
          <button onClick={() => setMobile(false)} className={btnGhost} data-testid="preview-desktop">Desktop</button>
          <button onClick={() => setMobile(true)} className={btnGhost} data-testid="preview-mobile">Mobilni</button>
        </div>
      </div>
      <article className={`mx-auto bg-background p-6 shadow-sm transition-all ${mobile ? "max-w-[390px]" : "max-w-[820px]"}`}>
        <p className="kicker">{ARTICLE_TYPES[a.article_type]}{a.article_type === "sponzorisano" && a.sponsor_name && ` · ${a.sponsor_name}`}</p>
        <h1 className={`hl mt-2 leading-tight ${mobile ? "text-[1.6rem]" : "text-[2.4rem]"}`}>{a.headline}</h1>
        {a.subheadline && <p className="dek mt-3 text-muted-foreground">{a.subheadline}</p>}
        <p className="mt-3 text-xs text-muted-foreground">Zadnja izmjena: {fmtDateTime(a.updated_at)}</p>
        {a.hero_image_url && <img src={imgSrc(a.hero_image_url)} alt={a.hero_image_alt} className="mt-5 aspect-[16/9] w-full object-cover" />}
        <div className="prose-news mt-6" dangerouslySetInnerHTML={{ __html: a.body_html }} />
      </article>
    </div>
  );
}
